import { useDispatch, useSelector } from 'react-redux'

import axios from '../api/axios'
import { setCredentials } from '../slices/authSlice'

const useRefreshToken = () => {
	const { refreshToken } = useSelector(state => state.auth)
	const dispatch = useDispatch()

	const refresh = async () => {
		const { data } = await axios.get('/account/refreshToken', {
			headers: {
				Authorization: `Bearer ${refreshToken}`
			}
		})

		dispatch(
			setCredentials({
				accessToken: data.accessToken
			})
		)

		return data.accessToken
	}

	return refresh
}

export default useRefreshToken
